import React, { useRef, useState } from 'react';
import Close from '../../../../Assets/Modals/closeIcon.svg';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../../../Features/orderDetailsSlice';
import { useOutsideClickHandler } from '../../../../Hooks/useOutsideClick';
import { showToast } from '../../../../Components/Toaster/Toaster';

function TrackingIDForm() {
    const dispatch = useDispatch();
    const wrapperRef = useRef(null);

    useOutsideClickHandler(wrapperRef, () => {
        dispatch(closeModal());
    });

    const [trackingID, setTrackingID] = useState('');

    const handleChange = (e) => {
        setTrackingID(e.target.value);
    }

    const handleButtonClick = () => {
        dispatch(closeModal());
    };

    const saveTrackingID = () => {
        if(trackingID) {
            dispatch(closeModal());
            showToast('Tracking ID Updated!', 'success');
        }
        else {
            showToast('Please add a tracking id to proceed!', 'warning');
        }
    }

    return (
        <div ref={wrapperRef} className="font-urbanist-regular w-1/2 h-fit bg-[#FFFFFF] rounded-xl p-6 flex flex-col gap-6 shadow-[0px_0px_12px_0px_#0000003D]">
            <div className="flex items-center justify-between">
                <h1 className='font-semibold text-2xl text-[#121212]'>Add/Replace Tracking ID</h1>

                <button onClick={handleButtonClick}>
                    <img src={Close} alt="Close Modal" />
                </button>
            </div>

            <div className="flex flex-col gap-2">
                    <label htmlFor='tracking-id' className='w-fit cursor-pointer m-0 font-medium text-base text-[#000000]'>
                        Enter Tracking ID
                    </label>

                    <div className="h-14 bg-[#F5F5F5] px-2 py-[6px] rounded-lg border border-[#EAEAEA] flex items-center justify-center">
                        <input 
                            placeholder='Enter id' 
                            className='w-full bg-transparent outline-none border-none text-sm font-medium placeholder:text-[#666666]' 
                            type="text" 
                            name='tracking-id' 
                            id='tracking-id' 
                            value={trackingID} 
                            onChange={handleChange} 
                        />
                    </div>
                </div>

                <button onClick={saveTrackingID} className='bg-primaryColor hover:bg-primaryAccent px-4 py-2 rounded font-semibold text-base text-center text-buttonText' type='button'>
                    Save Tracking ID
                </button>
        </div>
    );
}

export default TrackingIDForm;
